<template>
  <div
    class="packs-info-v4"
    :class="{'_active': active}"
  >
    <div class="packs-info-v4__name">
      <slot name="name" />
    </div>
    <div class="packs-info-v4__title">
      <slot name="title" />
    </div>
    <div class="packs-info-v4__subtitle">
      <slot name="subtitle" />
    </div>
    <div class="packs-info-v4__bottom">
      <slot name="bottom" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.packs-info-v4 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: .32rem .20rem .20rem;
  width: 2.00rem;
  height: 100%;
  border-radius: .16rem;
  font-size: .16rem;
  color: map-get($colors, 'black');
  background: map-get($colors, 'white');
  &__name {
    margin-bottom: auto;
    text-transform: uppercase;
    color: map-get($colors, 'secondary');
    @include typography('b3', 'bold');
  }
  &__title {
    margin-bottom: 0.08rem;
    text-align: center;
    @include typography('h1', 'bold');
    letter-spacing: 0.004rem;
  }
  &__subtitle {
    text-align: center;
    @include typography('b1', 'bold');
    letter-spacing: 0.0015rem;
    color: map-get($colors, 'grey_40');
  }
  &__bottom {
    margin-top: auto;
    width: calc(100% - .12rem);
  }
}
</style>
